"use client";

// src/components/atoms/GradientBackground/GradientBackground.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var GradientBackground = forwardRef(
  function GradientBackground2({ children, className }) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `overflow-hidden relative pt-80 pb-80  bg-[linear-gradient(178deg,#02271f_-0.36%,#004132_39.75%)] ${className}`,
        children: [
          /* @__PURE__ */ jsx("div", { className: "absolute inset-0 z-0 pointer-events-none", children: /* @__PURE__ */ jsxs(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 1920 907",
              fill: "none",
              preserveAspectRatio: "xMidYMid slice",
              className: "absolute top-0 left-0 z-behind w-full h-full pointer-events-none",
              children: [
                /* @__PURE__ */ jsx("g", { filter: "url(#filter0_f_1789_27973)", children: /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M-119 1052L697.859 254L1156.46 1016.72L2021 273.385",
                    stroke: "#009548",
                    strokeWidth: "200"
                  }
                ) }),
                /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
                  "filter",
                  {
                    id: "filter0_f_1789_27973",
                    x: "-338.88",
                    y: "-55.8789",
                    width: "2575.08",
                    height: "1375.67",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                      /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                      /* @__PURE__ */ jsx(
                        "feBlend",
                        {
                          mode: "normal",
                          in: "SourceGraphic",
                          in2: "BackgroundImageFix",
                          result: "shape"
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        "feGaussianBlur",
                        {
                          stdDeviation: "60",
                          result: "effect1_foregroundBlur_1789_27973"
                        }
                      )
                    ]
                  }
                ) })
              ]
            }
          ) }),
          children
        ]
      }
    );
  }
);
var GradientBackground_default = GradientBackground;

export {
  GradientBackground_default
};
